import { datadogRum } from '@datadog/browser-rum'

export default defineNuxtPlugin(() => {
  try {
    const config = useRuntimeConfig();

    datadogRum.init({
      applicationId: config.public.DATADOG_APP_ID,
      clientToken: config.public.DATADOG_CLIENT_TOKEN,
      site: 'us3.datadoghq.com',
      service: 'customer-account',
      env: config.public.DATADOG_ENVIRONMENT,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      defaultPrivacyLevel: 'mask-user-input',
    })

    datadogRum.startSessionReplayRecording()
  } catch (e) {
    console.log(`Unable to initialize Datadog client: ${e}`)
  }
})
